import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for the entire app
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Diagnostic logging to help with debugging (safe, no keys exposed)
if (!supabaseUrl) {
  console.warn('Missing REACT_APP_SUPABASE_URL environment variable');
}

if (!supabaseKey) {
  console.warn('Missing REACT_APP_SUPABASE_ANON_KEY environment variable');
}

// Create and export a supabase client if credentials are available
export const supabase = supabaseUrl && supabaseKey ? 
  createClient(supabaseUrl, supabaseKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true
    },
    global: {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  }) : null;
